module.exports = __webpack_public_path__ + "static/media/home_jml_library_btn.5dc012ba.png";